import React from 'react'
import { Box, HStack, VStack, Text } from '@chakra-ui/react'
import { FiFileText } from 'react-icons/fi'
import { FileItem } from '@/types'
import { useAppTranslation } from '@/contexts/LanguageContext'

interface FileInfoDisplayProps {
  file: FileItem
}

export function FileInfoDisplay({ file }: FileInfoDisplayProps) {
  const { t } = useAppTranslation('files')

  return (
    <Box p={4} bg="blue.25" borderRadius="lg" border="1px solid" borderColor="blue.100">
      <HStack spacing={3}>
        <Box p={2} bg="blue.100" borderRadius="md" color="blue.600">
          <FiFileText size="20px" />
        </Box>
        <VStack align="start" spacing={1}>
          <Text fontSize="md" fontWeight="semibold" color="blue.800">
            {file.display_name || file.original_name || file.name}
          </Text>
          <Text fontSize="sm" color="blue.600">
            {t('fileInfoDisplay.analysisDescription')}
          </Text>
        </VStack>
      </HStack>
    </Box>
  )
}
